module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sd-table-group"
  }, _vm._l((_vm.ticketList), function(result, ix) {
    return _c('div', {
      key: ix,
      staticClass: "sd-table-row"
    }, _vm._l((_vm.tableParams), function(column, ix) {
      return _c('div', {
        key: ix,
        staticClass: "sd-row-item",
        class: {
          clickable: _vm.tableParams[ix].clickable
        },
        style: ({
          'min-width': _vm.tableParams[ix].width,
          width: _vm.tableParams[ix].width,
        })
      }, [(column.renderDate) ? _c('a', [_vm._v("\n        " + _vm._s(_vm.renderDate(_vm.renderField(result, column.fields))) + "\n      ")]) : (column.clickable) ? _c('a', {
        attrs: {
          "href": _vm.renderHref(result.key)
        }
      }, [_vm._v("\n        " + _vm._s(_vm.renderField(result, column.fields, column.defaultValue)) + "\n      ")]) : _c('a', {
        class: (column.sortKey === 'status') ?
          'sd-status sd-' + result.fields.status.statusCategory.colorName :
          ''
      }, [_vm._v("\n        " + _vm._s(_vm.renderField(result, column.fields, column.defaultValue)) + "\n      ")])])
    }))
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4dd287cb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/JiraList.vue
// module id = 430
// module chunks = 1